
import { motion } from "framer-motion";
import { Coins, Users } from "lucide-react";

const FeaturesGrid = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      className="grid md:grid-cols-2 gap-6 mb-12"
    >
      <div className="bg-white/5 rounded-xl p-8 backdrop-blur-sm border border-white/10 hover:bg-white/10 transition-colors duration-300">
        <h3 className="text-2xl font-bold mb-6 text-racing-accent flex items-center gap-3">
          Upcoming Game Features
          <Coins className="w-6 h-6" />
        </h3>
        <ul className="space-y-4 text-gray-300">
          {[
            "Carefully breed the next champion",
            "Scout for talented jockeys",
            "Make high-stakes decisions on race day",
            "Free to play",
            "Win a share of the prize pool in $HRSE tokens"
          ].map((feature, index) => (
            <motion.li 
              key={index}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="flex items-center gap-3"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-racing-accent flex-shrink-0" />
              {feature}
            </motion.li>
          ))}
        </ul>
      </div>
      
      <div className="bg-white/5 rounded-xl p-8 backdrop-blur-sm border border-white/10 hover:bg-white/10 transition-colors duration-300">
        <h3 className="text-2xl font-bold mb-6 text-racing-accent flex items-center gap-3">
          Core Principles
          <Users className="w-6 h-6" />
        </h3>
        <ul className="space-y-4 text-gray-300">
          {[
            "Inclusivity - For all players, from beginners to experts",
            "Excitement - Constantly evolving competitions",
            "Ownership - Own and evolve digital assets",
            "Incentives - Earn $HRSE tokens through gameplay",
            "Competition - Build your own racing empire"
          ].map((principle, index) => (
            <motion.li 
              key={index}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="flex items-center gap-3"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-racing-accent flex-shrink-0" />
              {principle}
            </motion.li>
          ))}
        </ul>
      </div>
    </motion.div>
  );
};

export default FeaturesGrid;
